
import useGoToNavigation from '../../util/useGotoNavigation';
import { useTranslation } from 'react-i18next';

export const PasswordReset4 = () => {

    const { t, i18n } = useTranslation();
    const { goToNavigation } = useGoToNavigation();

    return (
        <>
            <div className="login_content">
                <div className="login_box">
                    <img src={process.env.PUBLIC_URL + "/images/assets/login_logo.png"} alt="" />
                    <div className="login_text">{t('pwReset4-resetpw-label')}</div>
                    <div className="login_msgbox">
                        <p>
                            inputEmail@gmail.com {t('pwReset4-resetpw-desc')}<br />{t('pwReset4-resetpw-desc2')}<br /><br />
                            {t('pwReset4-resetpw-desc3')}
                        </p>
                    </div>
                    <button className="btn btn-info btn-lg btn_login" onClick={()=>goToNavigation('login', "", true)}>{t('pwReset4-btn-label')}</button>
                </div>
            </div>
        </>
    );
}